import React from "react";
import { Grid2 } from "@mui/material";
import styles from "./ReadyPage.module.scss";
import { ReactComponent as DomainSuccess } from "../../../../../../../../GlobalAssets/svg/DomainSuccess.svg";

export default function ReadyPage({ message }) {
  return (
    <Grid2 className={styles.ReadyPageContainer}>
      <Grid2 className={styles.header}>
        {message ||
          "Your domain is being activated — you’ll be notified once it’s live."}
      </Grid2>
      <Grid2>
        <DomainSuccess />
      </Grid2>
    </Grid2>
  );
}
